import React, { useEffect, useState } from 'react';
import { Badge } from "../../components/ui/badge";
import { Alert, AlertDescription } from "../../components/ui/alert";
import { Rocket, XCircle, Atom } from "lucide-react";
import type { EnrichmentJob } from "wasp/entities";
import { useTranslation } from '../../i18n/hooks';

interface JobsViewHeaderProps {
  jobs: EnrichmentJob[];
  lastCompletedJob: EnrichmentJob | undefined;
}

const JobsViewHeader = ({ jobs, lastCompletedJob }: JobsViewHeaderProps) => {
  const [showBanner, setShowBanner] = useState(false);
  const { t } = useTranslation();
  
  useEffect(() => {
    if (lastCompletedJob?.endedAt) {
      const completionDate = new Date(lastCompletedJob.endedAt).getTime();
      const currentDate = new Date().getTime();
      const daysDifference = (currentDate - completionDate) / (1000 * 60 * 60 * 24);
      
      setShowBanner(daysDifference <= 3);
    }
  }, [lastCompletedJob]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-start">
        <div className="flex gap-4">
          <Atom 
            className="h-8 w-8 text-blue-500 mt-1"
            style={{
              filter: 'drop-shadow(0 0 4px rgba(59, 130, 246, 0.1))'
            }}
          />
          <div className="flex flex-col gap-1">
            <h1 className="text-xl md:text-3xl font-bold tracking-tight">
              {t('jobsView.content_innovation_lab')}
            </h1>
            <p className="text-gray-500">
              {t('jobsView.watch_products_get_better')}
            </p>
          </div>
        </div>

      </div>

      {/* Success Banner */}
      {showBanner && lastCompletedJob?.endedAt && (
  <Alert 
  variant="default" 
  className="bg-green-50 border-green-100"
>
  <div className="flex items-center w-full gap-3">
    <Rocket className="h-4 w-4 text-green-700 flex-shrink-0" />
    <AlertDescription className="flex justify-between items-center text-green-700 w-full">
      <div>
        {t('jobsView.last_enrichment_completed')} {new Date(lastCompletedJob.endedAt).toLocaleTimeString()}
      </div>
      <button 
        onClick={() => setShowBanner(false)}
        className="text-green-700 hover:text-green-900 flex-shrink-0"
      >
        <XCircle className="h-4 w-4" />
      </button>
    </AlertDescription>
  </div>
</Alert> 
      )}
    </div>
  );
};

export default JobsViewHeader;